import { createContext, type ReactNode, useContext } from "react";

import {
  type ArticleReactionsState,
  useArticleReactions,
} from "./useArticleReactions";

const ReactionsContext = createContext<ArticleReactionsState | null>(null);

export function ReactionsProvider({
  articleId,
  children,
}: {
  articleId?: string;
  children: ReactNode;
}) {
  const value = useArticleReactions(articleId);
  return (
    <ReactionsContext.Provider value={value}>
      {children}
    </ReactionsContext.Provider>
  );
}

export function useReactions(): ArticleReactionsState | null {
  return useContext(ReactionsContext);
}
